import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { AdminAction } from 'src/app/models/adminaction.model';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DetectlocationService } from 'src/app/services/detectlocation.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-accountdetails',
  templateUrl: './accountdetails.component.html',
  styleUrls: ['./accountdetails.component.css']
})
export class AccountdetailsComponent implements OnInit {
  schoolplan: any;
  //vcircleplan: any;
  accountdetails: any;
  school: any;
  allowTutorSendMail=false;
  adminActions: AdminAction[] = [];
  regionId!: number;
  stripeAccountStatus: any;
  requirements: any;
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;

  constructor(public headerinfo: ComponentheaderService, public schoolservice: SchoolmanagementService, 
    public billservice: BillingAccountService, public toastr: ToastrService, public router: Router, 
    public util: UtilService, private locationService: DetectlocationService, private paymentservice: PaymentService) {
  }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.regionId = await this.locationService.getRegionID();

    let schooldetails: any = await this.schoolservice.getSchoolDetails().toPromise().catch((err) => {
      this.toastr.error(err);
      return;
    });
    this.school = schooldetails.schoolInfo;
    if(this.school?.stripeAccountId?.length > 0){
      this.stripeAccountStatus = await this.paymentservice.getStripeAccountStatus(this.school?.stripeAccountId).toPromise();
    }
    this.allowTutorSendMail = this.school.allowTutorSendMail;
    // this.vcircleplan = await this.billservice.getCurrentVCirclePlan().toPromise().catch((err) => {
    //   this.toastr.error(err);
    // });
    const plan: any = await this.billservice.getCurrentSchoolPlan().toPromise().catch((err) => {
      this.toastr.error(err);
      return;
    });
    this.schoolplan = plan.plan;
    this.schoolplan.currentAccountExpiryDateString = plan.expirydatestring;

    this.adminActions = [

    ];
    this.headerinfo.setHeaderDisplay('Account Settings', [{ displaytext: 'Account Settings', route: '/account/accountsettings' }],this.adminActions)

    this.headerinfo.pageLoadingDone(this);

  }

  async gotoStripeLink(){
    const data: any = await this.paymentservice.createandGotoConnectAccountLink().toPromise();
    window.open(data.url, "_blank");  
  }
  // async vcircleclick() {
  //   if (!this.vcircleplan || this.vcircleplan.expired) {
  //     this.router.navigate(["/account/vcircleplan"]);
  //   }

  //   if (!this.vcircleplan.expired) {
  //     const confirmret = await this.util.confirm('Warning!!!', 'Current Plan Has Not Yet Expired, Are You Sure You Want To Change Plan?');
  //     if (confirmret) {
  //       this.router.navigate(["/account/vcircleplan"]);
  //     }
  //   }
  // }

}
